import React from 'react'
import { withFormikSupport } from '../../hocs/withFormikSupport'
import * as S from './styled'
import type { SwitchProps } from './types'

export const SwitchComponent = ({
  name,
  id,
  label,
  description,
  value,
  disabled,
  side = 'left',
  size = 'medium',
  onBlur,
  onChange,
}: SwitchProps) => {
  return (
    <S.Container
      $disabled={disabled}
      $side={side}
      $checked={!!value}
      $size={size}
      data-testid="Switch"
    >
      <div>
        <input
          type="checkbox"
          id={id}
          hidden
          name={name}
          value={value?.toString()}
          checked={!!value}
          disabled={disabled}
          onChange={onChange}
          onBlur={onBlur}
        />
        <S.Track $size={size}>
          <S.Handle $size={size} />
        </S.Track>
      </div>
      {(label || description) && (
        <div>
          {label && <S.Label>{label}</S.Label>}
          {description && <S.Description>{description}</S.Description>}
        </div>
      )}
    </S.Container>
  )
}

export const Switch = withFormikSupport(SwitchComponent)
